export default ['CN'];
